<template>
    <v-row justify="center">
        <v-dialog
            v-model="dialog"
            :persistent='true'
            width="1520px"
            height="100%"
            no-click-animation
            >
            <div
                :class="{ 'd-none': loading }"
            >
                <v-card class="cardWrap">
                    <CardTitle :title="page_title" />
                    <v-container class="mx-2">
                        <v-row no-gutters>
                            <v-col cols="4" :class="labelObj">
                                <div>{{ golfCourseName }}</div>
                            </v-col>
                            <v-col cols="2">
                                <v-select
                                    class="mr-3"
                                    :items="yearInSelectBox"
                                    item-value="year"
                                    item-text="year"
                                    v-model="search.year"
                                    label="年"
                                />
                            </v-col>
                            <v-col cols="2">
                                <v-select
                                    :items="monthInSelectBox"
                                    v-model="search.month"
                                    class="mr-3"
                                    label="月"
                                />
                            </v-col>
                            <v-col cols="2">
                                <v-select
                                    :items="courseInSelectBox"
                                    item-value="course_code"
                                    item-text="course_name"
                                    label="コース名"
                                    v-model="search.course"
                                />
                            </v-col>
                            <v-col cols="2">
                                <v-btn
                                    :disabled="btn[1].isActive"
                                    color="primary"
                                    class="ml-5 mt-4"
                                    @click="clickSearch"
                                >検索</v-btn>
                            </v-col>
                        </v-row>
                        <v-row no-gutters>
                            <div>{{ propsPlanName }}</div>
                        </v-row>
                        <v-row no-gutters>
                            <v-col cols="4">
                                <v-radio-group
                                    v-model="search.day"
                                    row
                                >
                                    <v-radio
                                        v-for="d in dayInSelectBox"
                                        :key="d.id"
                                        :label="d.code_name"
                                        :value="d.code"
                                    />
                                </v-radio-group>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field
                                    maxlength="2"
                                    placeholder="01"
                                    inputmode="tel"
                                    v-model="input.playDateFrom"
                                    :prefix="dateFromPre"
                                    :disabled="search.day !== 4"
                                    :rules="[
                                        rules.format_date,
                                        rules.correctDateBetween
                                    ]"
                                >
                                    <template v-slot:append-outer>
                                        <span class="mt-2">~</span>
                                    </template>
                                </v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field
                                    class="px-3"
                                    maxlength="2"
                                    placeholder="01"
                                    inputmode="tel"
                                    :prefix="dateToPre"
                                    v-model="input.playDateTo"
                                    :disabled="search.day !== 4"
                                    :rules="[
                                        rules.format_date,
                                        rules.correctDateBetween
                                    ]"
                                />
                            </v-col>
                        </v-row>
                        <v-form ref="form">
                            <v-row no-gutters>
                                <v-col cols="2">
                                    <v-text-field
                                        class="px-3"
                                        maxlength="2"
                                        label="時間指定"
                                        type="time"
                                        v-model="input.playStartFrom"
                                        :rules="[rules.required]"
                                    >
                                        <template v-slot:append-outer>
                                            <span class="mt-2">~</span>
                                        </template>
                                    </v-text-field>
                                </v-col>
                                <v-col cols="2">
                                    <v-text-field
                                        class="px-3"
                                        maxlength="2"
                                        label="時間指定"
                                        type="time"
                                        v-model="input.playStartTo"
                                        :rules="[rules.required]"
                                    />
                                </v-col>
                                <v-col cols="2" offset="3">
                                    <v-btn
                                        class="px-3"
                                        color="primary"
                                        @click="isChangeCheckbox"
                                    >指定した条件でチェック</v-btn>
                                </v-col>
                                <v-col cols="2">
                                    <v-btn
                                        class="px-3"
                                        color="primary"
                                        @click="isCheckClear"
                                    >全てのチェックをクリア</v-btn>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-container>
                    <v-data-table
                        :headers="headers"
                        :items="desserts"
                        hide-default-footer
                        class="elevation-1"
                        disable-pagination
                        fixed-header
                    >
                        <template v-slot:item="{ item }">
                            <tr>
                                <td>{{ item.displayPlayStart }}</td>
                                <template v-for="(cell, i, day) in item.days">
                                    <td :key="cell.key">
                                        <input
                                            type="checkbox"
                                            v-model="cell.releaseFlag"
                                            v-if="cell.releaseFlag !== null"
                                            @click="createSendData(cell.key, day + 1, item.play_start, item.course_code, !cell.releaseFlag)"
                                        >
                                    </td>
                                </template>
                            </tr>
                        </template>
                    </v-data-table>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="green darken-4" text @click="CloseModal">閉じる</v-btn>
                        <v-btn
                            color="green darken-4"
                            text
                            :disabled="SendEmptyReturnTrue || btn[2].isActive"
                            @click="displayAddOverLay">更新</v-btn>
                    </v-card-actions>
                    <AddOverlay
                        page-name="枠連携"
                        @processing="updateReleaseFlag"
                        @cancel="closeAddOverLay"
                        :process-result="process"
                        :OverlaySwitch="addOverlay"
                    />
                </v-card>
            </div>
        </v-dialog>
    </v-row>
</template>

<script>
import validater from '../../../lib/validater';
import CardTitle from '@/components/module/CardTitle';
import AddOverlay from '@/components/overlay/AddOverlay';
// mixins
import { authorityMixin } from '@/views/authorityMixin';
import { utilityMixin } from '../../../mixins/utility';
import { judgeDayMixin } from '../../../mixins/judgeDay';
// graghql
import {
    GET_GOLF_COURSE,
    GET_RELEASE_FLAG_FROM_PLAN_CELLS,
    UPDATE_RELEASE_FLAG } from '@/constants/plan';
import { GET_COURSE_LIST } from '@/constants/cell_info';
import { CODE_MASTER } from '@/views/config';
import { GET_LINK_YEARS } from '@/constants/reserve';

export default {
    components: {
        CardTitle,
        AddOverlay
    },
    mixins: [
        authorityMixin,
        utilityMixin,
        judgeDayMixin
    ],
    props: [
        'dialog',
        'golfCourseCode',
        'propsPlanName',
        'golfSelectProps',
        'propsPlanId'
    ],
    data () {
        return {
            addOverlay: false,
            golfGroupCode: process.env.VUE_APP_GROUP_CODE,
            // 年の選択ボックス
            yearInSelectBox: [],
            // 月の選択ボックス
            monthInSelectBox: [],
            // コースの選択ボックス
            courseInSelectBox: [],
            // 日の選択ボックス
            dayInSelectBox: [
                { code: 1, code_name: '全日' },
                { code: 2, code_name: '平日' },
                { code: 3, code_name: '休日' },
                { code: 4, code_name: '期間指定' }
            ],
            // 検索値
            search: {
                course: '',
                year: '',
                month: '',
                day: 1
            },
            // 入力値
            input: {
                playDateFrom: '',
                playDateTo: '',
                playStartTo: '',
                playStartFrom: ''
            },
            process: {
                // 処理結果
                result: '',
                // 処理結果メッセージ
                resultText: '',
                // 処理中かどうか
                processing: false
            },
            // データテーブルに渡す値
            desserts: [],
            // データテーブルの見出し要素
            headers: [],
            // 送信するデータ
            sendData: [],
            // 週のデータ
            dayOfWeek: [
                { id: CODE_MASTER.SUNDAY['id'], name: CODE_MASTER.SUNDAY['name'] },
                { id: CODE_MASTER.MONDAY['id'], name: CODE_MASTER.MONDAY['name'] },
                { id: CODE_MASTER.TUESDAY['id'], name: CODE_MASTER.TUESDAY['name'] },
                { id: CODE_MASTER.WEDNESDAY['id'], name: CODE_MASTER.WEDNESDAY['name'] },
                { id: CODE_MASTER.THURSDAY['id'], name: CODE_MASTER.THURSDAY['name'] },
                { id: CODE_MASTER.FRIDAY['id'], name: CODE_MASTER.FRIDAY['name'] },
                { id: CODE_MASTER.SATURDAY['id'], name: CODE_MASTER.SATURDAY['name'] }
            ],
            // モーダルタイトル コンポーネントに渡す値：モーダルタイトル
            page_title: '枠連携',
            // ゴルフ場名
            golfCourseName: '',
            // ボタンの活性・非活性
            btn: [
                { element_id: '000', element_name: '画面', isActive: true },
                { element_id: '001', element_name: '検索', isActive: true },
                { element_id: '002', element_name: '更新', isActive: true }
            ],
            vue_id: 'SCR0028',
            count: 0,
            offset: 0,
            dateFromPre: '',
            dateToPre: '',
            loading: false,
            labelObj: {
                'd-flex': true,
                'justify-start': true,
                'align-self-center': true,
                'py-2': true,
                'wordKeep': true
            },
            rules: {
                // 必須項目
                required: value => !!value || this.$t('error.validation.required.any'),
                format_date: value => validater.checkStringType(value) || this.$t('error.validation.stringtype'),
                // 期間指定専用
                correctDateBetween: value => this.checkCorrectDate(value) || this.$t('error.validation.date.Correct')
            }
        };
    },
    async created () {
        let now = new Date();
        let years = await this.getLinkYears();
        this.yearInSelectBox.push(...years);
        let nowYear = now.getFullYear();
        let nowMonth = now.getMonth() + 1;
        for (let i = 1; i <= 12; i++) {
            this.monthInSelectBox.push(String(i));
        }
        this.admin = await this.getLoginAdmin();
        await this.getAuthorityList();
        this.$set(this.search, 'year', String(nowYear));
        this.$set(this.search, 'month', String(nowMonth));
    },
    watch: {
        // 親からデータが渡ってきたときに発火
        golfCourseCode () {
            if (this.golfCourseCode !== '') {
                const golfCourseData = this.golfSelectProps.find(el => el.golf_code === this.golfCourseCode);
                this.golfCourseName = golfCourseData['golf_name'];
                this.makeHeaders();
                this.getCourseList();
            }
        },
        search: {
            handler (val) {
                this.dateFromPre = this.search.year + '-' + this.search.month.padStart(2, '0') + '-';
                this.dateToPre = this.search.year + '-' + this.search.month.padStart(2, '0') + '-';
            },
            deep: true
        }
    },
    computed: {
        formatedTimeFrom () {
            if (this.input.playStartFrom.length === 2) {
                return this.input.playStartFrom + ':';
            }
            return this.input.playStartFrom;
        },
        formatedTimeTo () {
            if (this.input.playStartTo.length === 2) {
                return this.input.playStartTo + ':';
            }
            return this.input.playStartTo;
        },
        SendEmptyReturnTrue () {
            return this.sendData.length === 0;
        }
    },
    methods: {
        /** --------------------------------------------
        * ヘッダーを作成
        *-------------------------------------------- */
        makeHeaders () {
            const targetDays = new Date(this.search.year, this.search.month, 0).getDate();
            let dayList = [{ text: '時間', aligh: 'center', value: 'play_start', sortable: false, class: 'playStart' }];
            for (let i = 1; i <= targetDays; i++) {
                let targetDate = new Date(`${this.search.year}-${this.search.month}-${i}`);
                let targetDay = this.dayOfWeek[targetDate.getDay()]['name'];
                if (i < 10) {
                    dayList.push({
                        text: '0' + i + targetDay,
                        align: 'center',
                        sortable: false,
                        value: 'day' + i,
                        class: 'dayWidth' + this.judgeDay(targetDate)
                    });
                } else {
                    dayList.push({
                        text: i + targetDay,
                        align: 'center',
                        sortable: false,
                        value: 'day' + i,
                        class: 'dayWidth' + this.judgeDay(targetDate)
                    });
                }
            }
            this.headers = dayList;
        },
        /** --------------------------------------------
        * ループ処理
        *-------------------------------------------- */
        async getReleaseFlagList () {
            this.$store.commit('loading/setIsLoading', true);
            this.loading = true;
            this.makeHeaders();
            this.desserts.splice(0, this.desserts.length);
            const records = await this.getReleaseFlag();
            let key = 0;
            records.forEach(record => {
                Object.keys(record.days).forEach(function (day, index) {
                    if (day === '__typename') return delete record.days[day];

                    let releaseFlag = record.days[day];
                    releaseFlag = releaseFlag === null ? null : Boolean(releaseFlag);
                    record.days[day] = {
                        'key': key,
                        'releaseFlag': releaseFlag,
                        'day': index + 1
                    };
                    key++;
                });
                this.desserts.push(record);
            });
            this.loading = false;
            this.$store.commit('loading/setIsLoading', false);
        },
        /** --------------------------------------------
        * 表のセル情報を取得
        * -------------------------------------------- */
        getReleaseFlag () {
            return this.$apollo.mutate({
                mutation: GET_RELEASE_FLAG_FROM_PLAN_CELLS,
                variables: {
                    golf_group_code: this.golfGroupCode,
                    golf_code: this.golfCourseCode,
                    plan_id: this.propsPlanId,
                    course_code: this.search.course,
                    year: this.search.year,
                    month: this.search.month.padStart(2, '0')
                }
            }).then(res => {
                for (let release of res.data.getReleaseFlag) {
                    release.displayPlayStart = this.timeFormated(release.play_start);
                }
                return res.data.getReleaseFlag;
            });
        },
        timeFormated (data) {
            const time = data.split(':');
            return time[0] + ':' + time[1];
        },
        /** --------------------------------------------
        * コースを取得
        *-------------------------------------------- */
        getCourseList () {
            this.$apollo.query({
                query: GET_COURSE_LIST,
                variables: {
                    golf_group_code: this.golfGroupCode,
                    golf_code: this.golfCourseCode
                }
            }).then(res => {
                this.courseInSelectBox = res.data.GetCoursesList;
                this.search.course = this.courseInSelectBox[0].course_code;
            });
        },
        /** --------------------------------------------
        * ゴルフ場ネームを取得
        * -------------------------------------------- */
        getGolfCourseName () {
            this.$apollo.query({
                query: GET_GOLF_COURSE,
                variables: {
                    golf_group_code: this.golfGroupCode,
                    golf_code: this.golfCourseCode
                }
            }).then(res => {
                this.golfCourseName = res.data.getGolfCourse[0].golf_name;
            });
        },
        /** --------------------------------------------
        * 更新処理
        * -------------------------------------------- */
        updateReleaseFlag () {
            this.$store.commit('loading/setIsLoading', true);
            this.loading = true;
            this.$apollo.mutate({
                mutation: UPDATE_RELEASE_FLAG,
                variables: {
                    releaseInput: this.sendData
                }
            }).then(res => {
                const result = res.data.UpdateReleaseFlagToCellInfos.result;
                if (result !== 0) {
                    this.closeAddOverLay();
                    // this.CloseModal();
                    this.sendData.splice(0, this.sendData.length);
                    this.loading = false;
                    this.$store.commit('loading/setIsLoading', false);
                } else if (result === 0) {
                    throw new Error('更新する情報がありませんでした。');
                }
            }).catch(error => {
                const e = error.message.split(':');
                this.$set(this.process, 'result', 0);
                this.$set(this.process, 'resultText', e[0]);
                this.loading = false;
                this.$store.commit('loading/setIsLoading', false);
            });
        },
        /** --------------------------------------------
        * チェックボタンの処理
        * -------------------------------------------- */
        isChangeCheckbox () {
            if (this.$refs.form.validate()) {
                const fromTime = this.input.playStartFrom + ':' + '00';
                const toTime = this.input.playStartTo + ':' + '00';
                this.desserts.forEach(record => {
                    const playTime = record['play_start'];
                    if (fromTime <= playTime && playTime <= toTime) {
                        Object.keys(record.days).forEach(day => {
                            let dayObj = record.days[day];
                            let now = new Date(`${this.search.year}-${this.search.month}-${dayObj.day}`);
                            let holiday = this.judgeDay(now);
                            const weekDay = String(now.getDay());
                            switch (this.search.day) {
                            case 1:
                                this.createDateObj(record, dayObj);
                                break;
                            case 2:
                                if (weekDay !== CODE_MASTER.SUNDAY['id'] && weekDay !== CODE_MASTER.SATURDAY['id']) {
                                    if (holiday !== 0) {
                                        this.createDateObj(record, dayObj);
                                    }
                                }
                                break;
                            case 3:
                                if (weekDay === CODE_MASTER.SUNDAY['id'] || weekDay === CODE_MASTER.SATURDAY['id'] || holiday === 0) {
                                    this.createDateObj(record, dayObj);
                                }
                                break;
                            case 4:
                                const fromDate = new Date(`${this.search.year}-${this.search.month}-${this.input.playDateFrom}`).getTime();
                                const toDate = new Date(`${this.search.year}-${this.search.month}-${this.input.playDateTo}`).getTime();
                                if (dayObj.day < 10) {
                                    now = new Date(`${this.search.year}-${this.search.month}-0${dayObj.day}`);
                                }
                                const nowDate = new Date(now).getTime();
                                if (fromDate <= nowDate && nowDate <= toDate) {
                                    this.createDateObj(record, dayObj);
                                }
                                break;
                            }
                        });
                    }
                });
            }
        },
        /** --------------------------------------------
        * 送信するデータを作成
        *-------------------------------------------- */
        createSendData (key, date, time, courseCode, releaseFlag) {
            // 同じキーを検索
            const someKey = this.sendData.findIndex(el => el.key === key);
            // 日にちをフォーマットする
            const formatDay = this.formatedDate(date);
            if (someKey !== -1) {
                // キーが同じものがある場合、古いものを削除
                this.sendData.splice(someKey, 1);
            }
            this.sendData.push({
                golf_group_code: this.golfGroupCode,
                golf_code: this.golfCourseCode,
                key: key,
                course_code: courseCode,
                date: formatDay,
                play_start: time,
                release_flag: releaseFlag,
                plan_id: this.propsPlanId
            });
        },
        /** --------------------------------------------
        * 送信するデータを作成する
        * -------------------------------------------- */
        createDateObj (record, dayObj) {
            if (dayObj.releaseFlag !== null) {
                dayObj.releaseFlag = true;
                this.createSendData(dayObj['key'], dayObj.day, record['play_start'], record['course_code'], dayObj['releaseFlag']);
            }
        },
        /** --------------------------------------------
        * フォーマットされた日付を作成する 例:2020-08-01
        * -------------------------------------------- */
        formatedDate (date) {
            return this.search.year + '-' +
                   this.search.month.padStart(2, '0') + '-' +
                   String(date).padStart(2, '0');
        },
        /** --------------------------------------------
        * 「全てのチェックをクリア」ボタンの処理
        * -------------------------------------------- */
        isCheckClear () {
            this.$refs.form.resetValidation();
            this.desserts.forEach(record => {
                Object.keys(record.days).forEach(day => {
                    if (record.days[day]['releaseFlag']) {
                        record.days[day]['releaseFlag'] = false;
                        const oldIndex = this.sendData.findIndex(data => data.key === record.days[day]['key']);
                        if (oldIndex !== -1) {
                            this.sendData.splice(oldIndex, 1);
                        }
                        const date = this.formatedDate(record.days[day]['day']);
                        this.sendData.push({
                            golf_group_code: this.golfGroupCode,
                            golf_code: this.golfCourseCode,
                            key: record.days[day]['key'],
                            course_code: record['course_code'],
                            date: date,
                            play_start: record['play_start'],
                            release_flag: record.days[day]['releaseFlag'],
                            plan_id: this.propsPlanId
                        });
                    }
                });
            });
        },
        /** --------------------------------------------
        * 検索ボタン処理
        * -------------------------------------------- */
        clickSearch () {
            this.$refs.form.resetValidation();
            this.getReleaseFlagList();
        },
        /** ----------------------------------------------
         * モーダル画面を表示する処理
         * ---------------------------------------------- */
        displayAddOverLay () {
            this.addOverlay = true;
        },
        /** ----------------------------------------------
         * 追加ダイアログを閉じる
         * ---------------------------------------------- */
        closeAddOverLay (item) {
            this.process.result = '';
            this.addOverlay = false;
        },
        /** ----------------------------------------------
         * モーダル画面を閉じる際の処理
         * ---------------------------------------------- */
        CloseModal () {
            this.$refs.form.resetValidation();
            this.sendData.splice(0, this.sendData.key);
            this.desserts.splice(0, this.desserts.length);
            this.$emit('close');
        },
        getLinkYears () {
            return this.$apollo.mutate({
                mutation: GET_LINK_YEARS,
                variables: { golfGroupCode: process.env.VUE_APP_GROUP_CODE }
            }).then(res => {
                return res.data.GetLinkYears.YearList;
            }).catch(error => {
                this.result = 0;
                this.error = error;
            });
        },
        // 期間指定実在日チェック
        checkCorrectDate (str) {
            if (str) {
                let day = this.dateFromPre + str;
                var delim = '-';
                var arr = day.split(delim);
                if (arr.length !== 3) return false;
                if (arr[0] < 1900) return false;
                const date = new Date(arr[0], arr[1] - 1, arr[2]);
                if (arr[0] !== String(date.getFullYear()) || arr[1] !== ('0' + (date.getMonth() + 1)).slice(-2) || arr[2] !== ('0' + date.getDate()).slice(-2)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return true;
            }
        }
    }
};
</script>

<style scoped>

    .v-data-table ::v-deep .v-data-table__wrapper{
        overflow: hidden;
        overflow-y: scroll;
        overflow-x: scroll;
        display: block;
        /* white-space: nowrap; */
        -webkit-overflow-scrolling: touch;
        min-height: 200px;
        max-height: 450px;
        width: 100%;
        text-align: center;
    }

    /* .v-data-table ::v-deep td{
        padding: 0 8px;
    } */

    div.v-input--radio-group__input{
        flex-wrap: nowrap;
    }

    .v-radio ::v-deep label{
        word-break: keep-all;
    }

    .v-data-table ::v-deep .wordKeep{
        word-break: keep-all;
    }

    .v-data-table ::v-deep .playStart {
        width: 125px;
    }

    .v-data-table ::v-deep th.dayWidth0 {
        padding: 11px;
        color: #DD0000 !important;
    }

    .v-data-table ::v-deep th.dayWidth1{
        padding: 11px;
    }
    .v-data-table ::v-deep th.dayWidth2{
        padding: 11px;
    }
    .v-data-table ::v-deep th.dayWidth3{
        padding: 11px;
    }
    .v-data-table ::v-deep th.dayWidth4{
        padding: 11px;
    }
    .v-data-table ::v-deep th.dayWidth5 {
        padding: 11px;
    }

    .v-data-table ::v-deep th.dayWidth6 {
        padding: 11px;
        color: #0000CC !important;
    }

</style>
